export enum TipoAcaoInatividadeEnum {
  MENSAGEM = 'MENSAGEM',
  FLUXO = 'FLUXO'
}
